import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import api from "../lib/api";
import { DirectoryWizardModal } from "./masters/DirectoryWizardModal";

// A POC dropdown scoped to ONE company's directory people — no cross-company leakage.
// Used for the LR pickup/delivery POC so a delivery-company person never shows up
// in the pickup POC list. Includes the "＋ Add to directory" wizard for new people.
export function ScopedPocPicker({ companyName, customers = [], value = "", onPick, reloadCustomers, testPrefix, placeholder = "Select POC" }) {
  const [pocs, setPocs] = useState([]);
  const [wizOpen, setWizOpen] = useState(false);
  const company = customers.find(
    (c) => (c.name || "").trim().toLowerCase() === (companyName || "").trim().toLowerCase());

  async function load() {
    if (!company) { setPocs([]); return; }
    const r = await api.get(`/directory/company/${company.id}`).catch(() => null);
    setPocs(r ? (r.data.employees || []) : []);
  }
  useEffect(() => { load(); }, [company?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  // Instant sync when a POC/company is added anywhere.
  useEffect(() => {
    const h = () => load();
    window.addEventListener("directory-changed", h);
    return () => window.removeEventListener("directory-changed", h);
  }, [company?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const knownName = pocs.find((p) => p.name === value);

  return (
    <div>
      <select
        className="input-field"
        value={knownName?.id || ""}
        disabled={!company}
        onChange={(e) => { const p = pocs.find((x) => x.id === e.target.value); if (p) onPick?.({ name: p.name, phone: p.phone || "", email: p.email || "" }); }}
        data-testid={`${testPrefix}-select`}
      >
        <option value="">{!company ? "Pick the company above first" : pocs.length ? placeholder : `No POCs for ${company.name}`}</option>
        {pocs.map((p) => <option key={p.id} value={p.id}>{p.name}{p.designation ? ` · ${p.designation}` : ""}{p.phone ? ` · ${p.phone}` : ""}</option>)}
      </select>
      {value && !knownName && (
        <div className="text-[10px] text-[#A0522D] mt-0.5" data-testid={`${testPrefix}-unlinked`}>"{value}" isn't in {company?.name || "the directory"} yet — add it below</div>
      )}
      <button type="button" className="text-[10px] text-[#C84B31] hover:underline mt-1 inline-flex items-center gap-1" onClick={() => setWizOpen(true)} data-testid={`${testPrefix}-add`}>
        <Plus className="w-3 h-3" /> Add to directory
      </button>
      <DirectoryWizardModal open={wizOpen} onClose={() => setWizOpen(false)} onChange={async () => { if (reloadCustomers) await reloadCustomers(); await load(); }} />
    </div>
  );
}
